
import { Component, Mixins, Prop } from 'vue-property-decorator'
import { CampsiteDetails } from '~/apps/campsite-details/types'
import AuthMixin from '~/mixins/AuthMixin'
import { AddReviewStateMachineInterpreter } from '../machine'

@Component({
  layout: 'user-account',
})
export default class AddAReview extends Mixins(AuthMixin) {
  @Prop()
    campsite: CampsiteDetails

  @Prop()
    booking: AddReviewStateMachineInterpreter['state']['context']['booking']

  @Prop()
    token: string

  @Prop()
    errors: Record<string, string>

  @Prop()
    states: string[]

  get reviewPhoto() {
    if (this.booking && this.booking.primaryPhoto) {
      return this.booking.primaryPhoto
    }
    return this.campsite.primaryPhoto
  }

  get ratingObject() {
    if (!this.campsite.rating) return undefined
    return {
      rate: this.campsite.rating * 2,
      votes: this.campsite.rateCount,
    }
  }
}
